import * as React from 'react';
import Checkbox from './form/Checkbox';

interface Props {
    cardTitle: string;
    cardOpen: boolean;
    onCardOpenChange: (newCardOpen: boolean) => void;
    children?: JSX.Element;
    isCheckbox?: boolean;
    collapseStyle?: any;
    isDisabled?: boolean;
}

const CollapsibleCard = (props: Props) => (
    <div className="card config-card">
        <div className="card-header">
            <div className="row">
                <div className="font-weight-bold col">{props.cardTitle}</div>
                <div className="d-flex col justify-content-end">
                    {props.isCheckbox !== false &&                    
                    <Checkbox
                        toggle={true}
                        onChange={() => {
                            if (!props.isDisabled) {
                                props.onCardOpenChange(!props.cardOpen);
                            }
                        }}
                        inputProps={{
                            id: `card-open-${props.cardTitle}`,
                            name: `cardOpen${props.cardTitle}`,
                            checked: props.cardOpen,
                            disabled: props.isDisabled
                        }}
                    />
                    }
                </div>
            </div>
        </div>
        {props.cardOpen && <div style={props.collapseStyle?props.collapseStyle:{}} className="card-body">{props.children}</div>}
    </div>
);

export default CollapsibleCard;



// WEBPACK FOOTER //
// ./src/components/common/CollapsibleCard.tsx